<script setup lang="ts">
/** AGM 문서의 Venue / Date / Time 표(템플릿 순서·대소문자 그대로). */
import CddVarField from '../../../preset/components/final-dividends/cdd/CddVarField.vue';

const props = withDefaults(defineProps<{
  /** 'vdt' = Venue·Date·Time(공지·동의·출석부), 'dtv' = Date·Time·Venue(+Present, 회의록) */
  order?: 'vdt' | 'dtv';
  upper?: boolean;
  withPresent?: boolean;
}>(), { order: 'vdt', upper: false, withPresent: false });

const L = (s: string) => (props.upper ? s.toUpperCase() : s);
</script>

<template>
  <table class="mt-tbl">
    <tbody>
      <template v-if="order === 'vdt'">
        <tr><td class="mt-l">{{ L('Venue') }}</td><td class="mt-c">:</td><td><CddVarField field-key="agm_venue" label="AGM Venue" /></td></tr>
        <tr><td class="mt-l">{{ L('Date') }}</td><td class="mt-c">:</td><td><CddVarField field-key="agm_date" label="AGM Date" /></td></tr>
        <tr><td class="mt-l">{{ L('Time') }}</td><td class="mt-c">:</td><td><CddVarField field-key="agm_time" label="AGM Time (e.g. 10:00 AM)" /></td></tr>
      </template>
      <template v-else>
        <tr><td class="mt-l">{{ L('Date') }}</td><td class="mt-c">:</td><td><CddVarField field-key="agm_date" label="AGM Date" /></td></tr>
        <tr><td class="mt-l">{{ L('Time') }}</td><td class="mt-c">:</td><td><CddVarField field-key="agm_time" label="AGM Time (e.g. 10:00 AM)" /></td></tr>
        <tr><td class="mt-l">{{ L('Venue') }}</td><td class="mt-c">:</td><td><CddVarField field-key="agm_venue" label="AGM Venue" /></td></tr>
        <tr v-if="withPresent"><td class="mt-l">{{ L('Present') }}</td><td class="mt-c">:</td><td>As per Attendance List.</td></tr>
      </template>
    </tbody>
  </table>
</template>

<style scoped>
.mt-tbl { border-collapse: collapse; margin: 6px 0 12px; }
.mt-tbl td { padding: 2px 6px; vertical-align: top; }
.mt-l { width: 90px; font-weight: 600; }
.mt-c { width: 12px; }
</style>
